module.exports = new __parcel__URL__("no-customers-or-orgs.e468116d.svg").toString();